<section class="detail-section" [hidden]="!(cruise$ | async)?.steps?.length">
  <h4 class="detail-section__title">Itinerario</h4>
  <div class="d-flex flex-wrap g-2 mb-3 col-11 col-md-10">
    <small class="fw-medium me-1">Itinerario: </small>
    <ng-container *ngFor="let step of (cruise$ | async)?.steps; let first = first; let last = last">
      <ng-container *ngFor="let harb of step.harbours; let indexHarb = index">
        <ng-container *ngIf="harb">
          <small class="harbour me-1" [class.text-muted]="(!first || indexHarb !== 0) && !last">
            {{ harb.data.Name }}
            <span *ngIf="first && indexHarb === 0">(Imbarco)</span>
            <span *ngIf="last">(Sbarco)</span>
          </small>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <hr />
  <div class="d-flex align-items-baseline justify-content-between">
    <h4 class="detail-section__title">Mappa</h4>
    <a
      class="d-block d-lg-none text-decoration-underline fs-xs cursor-pointer"
      (click)="collapse.toggle()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample"
    >
      {{ isCollapsed ? "Mostra" : "Nascondi" }}
    </a>
  </div>
  <div
    class="detail-content__itinerary"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="isCollapsed"
  >
    <div class="detail-content__steps position-relative">
      <swiper
        [config]="config"
        [(index)]="index"
        class="c-detail-slider detail-steps"
      >
        <ng-container *ngFor="let step of (cruise$ | async)?.steps">
          <div class="detail-steps__item">
            <div class="detail-content__single-step detail-content__single-step--carousel">
              <div class="detail-content__single-step-icon" [ngClass]="{ active: !step.isNavigation }">
                <i class="icon-pin-map"></i>
                <span>{{ step.day }}</span>
              </div>
              <div class="detail-content__single-step-detail">
                <span>Giorno {{ step.day }}</span>
                <ng-container *ngIf="step.isNavigation">
                  <h6 class="detail-content__single-step--harbour">
                    In Navigazione...
                  </h6>
                </ng-container>
                <ng-container *ngIf="!step.isNavigation">                  
                  <ng-container *ngFor="let harbour of step.harbours">
                    <h6 class="detail-content__single-step--harbour">
                      {{ harbour.data.Name }}
                    </h6>
                    <small [hidden]="!harbour.arrivalHour">
                      Arrivo alle {{ harbour.arrivalHour }}
                    </small>
                    <small [hidden]="!harbour.arrivalHour || !harbour.departureHour">
                      ,
                    </small>
                    <small [hidden]="!harbour.departureHour">
                      Partenza alle {{ harbour.departureHour }}
                    </small>
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <i class="icon-chevron-down detail-steps__arrow"></i>
          </div>
        </ng-container>
      </swiper>
    </div>
    <div class="detail-content__map">
      <div id="map-canvas" class="detail-map">
        <google-map (tiltChanged)="setBounds()" [width]="'auto'" #googleMapRef>
          <map-marker
            *ngFor="let step of markersSteps"
            [label]="step.label"
            [position]="step"
          >
          </map-marker>
          <map-polyline
            [options]="{ strokeColor: 'red' }"
            [path]="polylineSteps"
          >
          </map-polyline>
        </google-map>
      </div>
    </div>
  </div>
  <hr />
</section>
